"use strict";

exports.__esModule = true;
exports.isMobileBreakpoint = exports.getCurrentPageFromScrollOffset = exports.MOBILE_BREAKPOINT = exports.DOCUMENT_PADDING_TOP = void 0;

var _browser = _interopRequireDefault(require("../../../helpers/browser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MOBILE_BREAKPOINT = 576;
exports.MOBILE_BREAKPOINT = MOBILE_BREAKPOINT;
const DOCUMENT_PADDING_TOP = 46;
exports.DOCUMENT_PADDING_TOP = DOCUMENT_PADDING_TOP;

const isMobileBreakpoint = () => {
  return window.innerWidth < MOBILE_BREAKPOINT || _browser.default.isIOS() || _browser.default.isAndroid();
};
/**
 * helper method to get the current page number based on scroll offset from the top of the document
 * @param {Array} pageOffsetsArray - the array of page offsets from the top of the container
 * @param {Integer} scrollPosition - the scroll position
 */


exports.isMobileBreakpoint = isMobileBreakpoint;

const getCurrentPageFromScrollOffset = (pageOffsetsArray, scrollPosition) => {
  scrollPosition = scrollPosition - DOCUMENT_PADDING_TOP; // use a binary search to find the current page from the scroll offset

  if (pageOffsetsArray === undefined || pageOffsetsArray === null || scrollPosition < pageOffsetsArray[0]) {
    return 1;
  } else if (scrollPosition > pageOffsetsArray[pageOffsetsArray.length - 1]) {
    return pageOffsetsArray.length;
  }

  var lo = 0,
      hi = pageOffsetsArray.length - 1,
      mid;

  while (lo <= hi) {
    mid = Math.floor((lo + hi) / 2);

    if (pageOffsetsArray[mid] < scrollPosition && pageOffsetsArray[mid + 1] > scrollPosition) {
      return mid + 1;
    } else if (pageOffsetsArray[mid] > scrollPosition) {
      hi = mid - 1;
    } else if (pageOffsetsArray[mid] < scrollPosition) {
      lo = mid + 1;
    } else if (pageOffsetsArray[mid] === scrollPosition) {
      return mid + 1;
    }
  }
};

exports.getCurrentPageFromScrollOffset = getCurrentPageFromScrollOffset;